import React from "react";
import "./CallToActionSection.css";
import { useNavigate } from "react-router-dom";

const CallToActionSection = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  return (
    <section className="custom-cta-section">
      <h2 className="custom-cta-heading">Drop your details, we’ll handle the rest.</h2>
      <button className="custom-cta-button" onClick={handleContactClick}>
        Contact Us
      </button>
    </section>
  );
};

export default CallToActionSection;
